import { render, staticRenderFns } from "./singleCreateOrder.vue?vue&type=template&id=6f9ec49e&scoped=true&"
import script from "./singleCreateOrder.vue?vue&type=script&lang=js&"
export * from "./singleCreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./singleCreateOrder.vue?vue&type=style&index=0&id=6f9ec49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ec49e",
  null
  
)

export default component.exports